'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';

import { GameBoard } from '../../../../contentful/roll-and-move/game-board';
import { Missions } from '../../../../contentful/roll-and-move/missions';
import { Rewards } from '../../../../contentful/roll-and-move/rewards';
import { rollAndMoveBunja } from '../../../../contentful/roll-and-move/state';
import { registerCompetitionBunja } from '../../action';
import { EventPeriod } from '../../component/event-period';
import { SeparatorTitle } from '../../component/separator-title';
import { Rules } from '../rules';

export const RollAndMove = () => {
  const { rollAndDiceSectionLayout, rewardsAtom, currentGameAtom } = useBunja(rollAndMoveBunja);
  const currentGame = useAtomValue(currentGameAtom);
  const rewards = useAtomValue(rewardsAtom);
  const { registerCompetition: _registerCompetition } = useBunja(registerCompetitionBunja);

  const hasRewards = rewards.length > 0;

  if (!rollAndDiceSectionLayout) return null;

  return (
    <div className={css({ w: '100%' })}>
      <SeparatorTitle
        colorSet='keyColor'
        title={rollAndDiceSectionLayout.title}
        description={<EventPeriod start={currentGame?.startDate} end={currentGame?.endDate} />}
      />

      <div className={vstack({ gap: { base: 20, tablet: 32 }, pt: { base: 20, tablet: 32 } })}>
        <GameBoard />
      </div>

      {/* 상품 있으면: Rewards → Missions → Rules, 없으면: Rules → Missions */}
      {hasRewards ? (
        <>
          <Rewards />
          <Missions />
          <Rules />
        </>
      ) : (
        <>
          <Rules />
          <Missions />
        </>
      )}
    </div>
  );
};
